import { svg } from 'lit'

export const caratDown = svg`
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3 7.28114L10 14.3L17 7.28113L15.7055 6L10 11.7209L4.29449 6L3 7.28114Z" fill="currentColor"/>
  </svg>
`
